import { getColor, Table } from '@aircall/tractor-v2';
import { BRAND_COLORS } from '@constants/style.constants';
import styled from '@xstyled/styled-components';

export interface SampleUserData {
  email: string;
  firstName: string;
  lastName: string;
  supervisor?: string;
  admin?: string;
  owner?: string;
}

export const SAMPLE_DATA: SampleUserData[] = [
  {
    email: 'john.doe@aqme.com',
    firstName: 'John',
    lastName: 'Doe',
    supervisor: 'X',
    admin: 'X',
    owner: 'X',
  },
  {
    email: 'jane.smith@aqme.com',
    firstName: 'Jane Mary',
    lastName: 'Smith',
    supervisor: '',
    admin: '',
    owner: '',
  },
  {
    email: 'mike.brown@aqme.com',
    firstName: 'Mikel',
    lastName: 'Brown',
    supervisor: 'X',
    admin: '',
    owner: '',
  },
];

export const SampleTable = styled(Table)`
  pointer-events: none;

  thead > tr > th {
    background-color: ${BRAND_COLORS.BLUE.DARK};

    div {
      color: ${getColor('neutral-0')};
      font-size: ${({ theme: { typography } }) => typography.supportingSemiboldS.fontSize};
      font-weight: ${({ theme: { typography } }) => typography.supportingSemiboldS.fontWeight};
    }
  }

  tbody > tr {
    td {
      border-color: ${getColor('informative-100')};

      div {
        color: ${BRAND_COLORS.BLUE.DARK};
        font-size: ${({ theme: { typography } }) => typography.supportingMediumS.fontSize};
        font-weight: ${({ theme: { typography } }) => typography.supportingMediumS.fontWeight};
      }
    }

    td:nth-child(n + 4) div {
      text-align: center;
      width: 100%;
    }

    td:nth-child(odd) {
      background-color: ${BRAND_COLORS.BLUE.LIGHT};
    }
  }
`;
